import { render, staticRenderFns } from "./StatisticFeaturesCard.vue?vue&type=template&id=00a6c48f"
import script from "./StatisticFeaturesCard.vue?vue&type=script&lang=js"
export * from "./StatisticFeaturesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports